import messengersReducer from "./messengersReducer"
import {diffArrays} from "../../Utils/DiffUtils";
import {publish} from "../../Events/events";
import {DeleteUser, NewUser, UpdateUser} from "../../Events/topics";

const initialState = {
    users: [],
    activeMessengers: [],
    fetching: false,
    changing: false,
    fetched: false,
    error: null
};

const extensions = [messengersReducer];

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "FETCH_USERS_PENDING": {
            return {
                ...state,
                fetching: true
            };
        }
        case "FETCH_USERS_FULFILLED": {
            const diffUsers = diffArrays(state.users, action.payload, (obj) => obj.id);

            if (diffUsers.length > 0) {
                for (let diffUser of diffUsers) {
                    if (diffUser.type === "add")
                        publish(NewUser, {user: action.payload.find(o => o.id === diffUser.id)});
                    else if (diffUser.type === "remove")
                        publish(DeleteUser, {user: state.users.find(o => o.id === diffUser.id)});
                    else if (diffUser.type === "update") {
                        const ignoreChanges = [
                            'profiles.messenger.lastNonAvailableTimestamp',
                            'profiles.messenger.lastAvailableTimestamp',
                            'profiles.messenger.location.lng',
                            'profiles.messenger.location.lat',
                            'profiles.messenger.location.bearing',
                            'profiles.messenger.location.timestamp'
                        ];

                        const changes = diffUser.changes.filter(change => !ignoreChanges.includes(change.path.join('.')));

                        if (changes.length > 0)
                            publish(UpdateUser, {
                                user: action.payload.find(o => o.id === diffUser.id),
                                changes: changes
                            });
                    }
                }
            }

            return {
                ...state,
                users: diffUsers.length > 0 ? action.payload : state.users,
                fetching: false,
                fetched: true,
                error: null
            };
        }
        case "FETCH_USERS_REJECTED": {
            return {
                ...state,
                fetching: false,
                error: action.payload
            };
        }
        case "DELETE_USER_PENDING": {
            return {
                ...state,
                users: state.users.filter(user => user.id !== action.meta.uid),
                changing: true
            }
        }
        case "DELETE_USER_FULFILLED": {
            return {
                ...state,
                changing: false,
                error: null
            };
        }
        case "DELETE_USER_REJECTED": {
            return {
                ...state,
                changing: false,
                error: action.payload
            };
        }
        case "ADD_USER_PENDING": {
            return {
                ...state,
                users: [...state.users, action.meta],
                changing: true
            }
        }
        case "ADD_USER_FULFILLED": {
            return {
                ...state,
                changing: false,
                error: null
            };
        }
        case "ADD_USER_REJECTED": {
            return {
                ...state,
                changing: false,
                error: action.payload
            };
        }
        case "EDIT_USER_PENDING": {
            const newUsers = [...state.users];
            const foundUserIndex = state.users.findIndex(user => user.id === action.meta.id);
            newUsers[foundUserIndex] = action.meta;

            return {
                ...state,
                users: newUsers,
                changing: true
            }
        }
        case "EDIT_USER_FULFILLED": {
            return {
                ...state,
                changing: false,
                error: null
            };
        }
        case "EDIT_USER_REJECTED": {
            return {
                ...state,
                changing: false,
                error: action.payload
            };
        }
    }

    let newState = state;

    for (let extension of extensions)
        newState = extension(newState, action);

    return newState;
}